// extracted by mini-css-extract-plugin
module.exports = {"confirmModalContent":"styles_confirmModalContent__KJfW4","modalBody":"styles_modalBody__1_2dj","modalInfo":"styles_modalInfo__64IrU","modalBttns":"styles_modalBttns__2304s"};